import React from 'react';
import { ResilienceByIndustry as ResilienceByIndustryType } from '../../services/analyticsService';

interface Props {
  data: ResilienceByIndustryType;
}

const DEFAULT_INDUSTRIES = [
  { name: 'Finance', widthPct: 95 },
  { name: 'Healthcare', widthPct: 82 },
  { name: 'Manufacturing', widthPct: 74 },
  { name: 'Retail', widthPct: 62 },
];

const ResilienceByIndustryChart: React.FC<Props> = ({ data }) => {
  const industries = data?.industries?.length
    ? data.industries.slice(0, 4).map((ind, idx) => ({
        name: ind.industry,
        widthPct: Math.min(100, Math.max(40, Math.round((ind.resilience_score / 100) * 105))),
      }))
    : DEFAULT_INDUSTRIES;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40]">Resilience by Industry</h2>
      <p className="text-xs text-gray-500 mt-1 mb-3">Resilience by Industry</p>
      <div className="space-y-2">
        {industries.map((ind) => (
          <div key={ind.name} className="w-full">
            <div
              className="h-6 bg-[#3b82f6] rounded-md flex items-center px-2.5 text-white text-[11px] font-semibold tracking-wide transition-all duration-500"
              style={{ width: `${ind.widthPct}%` }}
            >
              {ind.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResilienceByIndustryChart;
